import { ArrowLeft, Home, Menu } from 'iconsax-react'
import { useTranslation } from 'react-i18next'

import { weCheckPalette } from '@/utils/palette/weCheckPalette'

import { WecheckEnvironmentDistinction } from '../WecheckEnvironmentDistinction/WecheckEnvironmentDistinction'

interface MobileTopBarProps {
  environment: string
  onMenuClick?: () => void
  onBack?: () => void
  useHomeIcon?: boolean
}

export const MobileTopBar = ({
  environment,
  onMenuClick,
  onBack,
  useHomeIcon = false,
}: MobileTopBarProps) => {
  const { t } = useTranslation()

  return (
    <div className="sticky top-0 z-30 flex shrink-0 items-center justify-between bg-transparent px-4 py-3 backdrop-blur-sm">
      <div className="flex items-center gap-2">
        {onBack && (
          <button
            type="button"
            onClick={onBack}
            aria-label={t('dashboard.common.goBack')}
            className="flex items-center"
          >
            {useHomeIcon ? (
              <Home size={20} color={weCheckPalette.neutralColor} />
            ) : (
              <ArrowLeft size={20} color={weCheckPalette.neutralColor} />
            )}
          </button>
        )}
        <WecheckEnvironmentDistinction environment={environment} />
      </div>

      {onMenuClick && (
        <button
          type="button"
          onClick={onMenuClick}
          aria-label="Open menu"
          className="flex h-6 w-6 items-center justify-center rounded-md bg-primary5"
        >
          <Menu size={16} color={weCheckPalette.neutralColor} variant="Bold" />
        </button>
      )}
    </div>
  )
}
